import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged, map, skipWhile } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { AppState, ReturnsStatusActionTypes } from '@app/core/ngrx';

@Component({
  selector: 'ecp-returns-status-details',
  templateUrl: './returns-status-details.component.html',
  styleUrls: ['./returns-status-details.component.scss'],
})
export class ReturnsStatusDetailsComponent implements OnInit, OnDestroy {
  @Input() returns;

  private searchSub$: Subscription;
  public search$: BehaviorSubject<any> = new BehaviorSubject(null);

  constructor(private store: Store<AppState>) {}

  ngOnInit(): void {
    this.searchSub$ = this.search$
      .pipe(
        skipWhile(event => !event),
        map(event => event.currentTarget.value),
        debounceTime(700),
        distinctUntilChanged(),
      )
      .subscribe(term => {
        this.store.dispatch({
          type: ReturnsStatusActionTypes.SEARCH_RETURNS_STATUS,
          payload: term,
        });
      });
  }
  ngOnDestroy(): void {
    if (this.searchSub$) this.searchSub$.unsubscribe();
  }
}
